import FollowingService from 'src/modules/following/followingService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'FOLLOWING_FORM';

const followingFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: followingFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await FollowingService.find(id);
      }

      dispatch({
        type: followingFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: followingFormActions.INIT_ERROR,
      });

      getHistory().push('/following');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: followingFormActions.CREATE_STARTED,
      });

      await FollowingService.create(values);

      dispatch({
        type: followingFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.following.create.success'),
      );

      getHistory().push('/following');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: followingFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: followingFormActions.UPDATE_STARTED,
      });

      await FollowingService.update(id, values);

      dispatch({
        type: followingFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.following.update.success'),
      );

      getHistory().push('/following');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: followingFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default followingFormActions;
